const originTrxCountDecider = (transactions = []) => {
  return transactions.filter(({ ancestor_id }) => !ancestor_id).length;
};

export default originTrxCountDecider;
